import { IconBadgeComponent, IconBadgeComponentV2, iconBadgeTemplate, iconBadgeTemplateV2 } from './IconBadge';
import oldStyles from './OldIconBadge.styles.scss';
import styles from './IconBadge.styles.scss';
export const iconBadgeDefinition = { baseName: 'icon-badge', template: iconBadgeTemplate, styles: oldStyles };
export const iconBadgeDefinitionV2 = { baseName: 'icon-badge-v2', template: iconBadgeTemplateV2, styles };
export const chameleonIconBadge = IconBadgeComponent.compose(iconBadgeDefinition);
export const chameleonIconBadgeV2 = IconBadgeComponentV2.compose(iconBadgeDefinitionV2);
